import { MfeFeatureName } from '../../app/core/components/mfe-router-wrapper/types/mfe';
import { MfeType } from '../../app/core/directives/wc-render/types/wc';
import { RolesEnum } from '../../app/enums/ipb-roles.enum';
import { PageType } from '../../app/interfaces';
import { MfeEnvironment } from './mfe-env.type';

export const mfeEnvHom: MfeEnvironment = {
	iframes: {
		'dashboard-mfe': {
			id: 'dashboard-mfe',
			config: {
				mfe: {
					elementName: 'mf-mfe-backoffice-dashboard',
					remoteEntry:
						'https://microfrontend.hom.cloud.itau.com.br/private/mf-mfe-backoffice-dashboard/#/',
					type: MfeType.WEB_COMPONENT,
				},
				roles: {
					enabled: [
						RolesEnum.ADMINISTRATOR,
						RolesEnum.MIDDLE_OFFICE_MANAGER,
						RolesEnum.MIDDLE_OFFICE_ANALYST,
						RolesEnum.HUB_SERVICE,
						RolesEnum.ACCOUNT_SERVICE,
					],
				},
				menu: {
					icon: 'installment_base',
					canBeSelected: true,
					title: 'Dashboard',
					isSelected: false,
					testid: 'dashboard',
					path: '/dashboard-mfe',
				},
			},
		},
	},
	mfes: {
		[MfeFeatureName.WIRE_TRANSFER]: {
			id: MfeFeatureName.WIRE_TRANSFER,
			config: {
				mfe: {
					elementName: 'mf-mfe-backoffice-wire-transfer',
					remoteEntry:
						'https://microfrontend.hom.cloud.itau.com.br/private/mf-mfe-backoffice-wire-transfer/main.js',
					type: MfeType.WEB_COMPONENT,
					connectedToChassisRoute: true,
				},
				roles: {
					enabled: [
						RolesEnum.ADMINISTRATOR,
						RolesEnum.MIDDLE_OFFICE_MANAGER,
						RolesEnum.MIDDLE_OFFICE_ANALYST,
						RolesEnum.HUB_SERVICE,
						RolesEnum.BANKING_SERVICE,
						RolesEnum.CREDIT_SERVICES
					],
				},
				menu: {
					icon: 'transaction_base',
					canBeSelected: true,
					title: 'Wire Transfers',
					isSelected: false,
					testid: 'wiretransfers',
					path: '/wire-transfer-mfe',
				},
			}
		},
		[MfeFeatureName.HOME]: {
			id: MfeFeatureName.HOME,
			config: {
				mfe: {
					elementName: 'mf-mfe-backoffice-home',
					remoteEntry:
						'https://microfrontend.hom.cloud.itau.com.br/private/mf-mfe-backoffice-home/main.js',
					type: MfeType.WEB_COMPONENT,
				},
				roles: {
					enabled: [] as RolesEnum[],
				},
				menu: {
					icon: 'home_base',
					title: 'Home Page',
					canBeSelected: true,
					isSelected: true,
					testid: 'home',
					path: '/home',
				},
			},
		},
		[MfeFeatureName.CUSTOMER]: {
			id: MfeFeatureName.CUSTOMER,
			config: {
				mfe: {
					elementName: 'mf-mfe-backoffice-customer',
					remoteEntry:
						'https://microfrontend.hom.cloud.itau.com.br/private/mf-mfe-backoffice-customer/main.js',
					type: MfeType.WEB_COMPONENT,
					connectedToChassisRoute: true,
				},
				roles: {
					enabled: [
						RolesEnum.ADMINISTRATOR,
						RolesEnum.HUB_SERVICE,
						RolesEnum.ACCOUNT_SERVICE,
						RolesEnum.MIDDLE_OFFICE_ANALYST,
						RolesEnum.MIDDLE_OFFICE_MANAGER,
						RolesEnum.BANKER,
					],
				},
				menu: {
					icon: 'user_base',
					canBeSelected: true,
					title: 'Clients',
					isSelected: false,
					testid: 'clients',
					path: '/customer-mfe',
				},
			},
		},
		[MfeFeatureName.REQUEST]: {
			id: MfeFeatureName.REQUEST,
			config: {
				mfe: {
					elementName: 'mf-mfe-backoffice-requests',
					remoteEntry:
						'https://microfrontend.hom.cloud.itau.com.br/private/mf-mfe-backoffice-requests/main.js',
					type: MfeType.WEB_COMPONENT,
					connectedToChassisRoute: true,
				},
				roles: {
					enabled: [
						RolesEnum.ADMINISTRATOR,
						RolesEnum.ACCOUNT_SERVICE,
					],
				},
				menu: {
					icon: 'list_base',
					canBeSelected: true,
					title: 'Requests',
					isSelected: false,
					testid: 'requests',
					path: '/requests-mfe',
				},
			},
		},
		[MfeFeatureName.INTERNAL_USER]: {
			id: MfeFeatureName.INTERNAL_USER,
			config: {
				mfe: {
					elementName: 'mf-mfe-backoffice-internal-user',
					remoteEntry:
						'https://microfrontend.hom.cloud.itau.com.br/private/mf-mfe-backoffice-internal-user/main.js',
					type: MfeType.WEB_COMPONENT,
					connectedToChassisRoute: true,
				},
				roles: {
					enabled: [RolesEnum.ADMINISTRATOR, RolesEnum.INFORMATION_SECURITY],
				},
				menu: {
					icon: 'user_change_base',
					title: 'Internal Users',
					canBeSelected: true,
					isSelected: true,
					testid: 'internalusers',
					path: '/internal-users-mfe',
				},
			},
		},
		[MfeFeatureName.SMA]: {
			id: MfeFeatureName.SMA,
			config: {
				mfe: {
					elementName: 'mf-mfe-sma',
					remoteEntry:
						'https://microfrontend.hom.cloud.itau.com.br/private/mf-mfe-sma/main.js',
					type: MfeType.WEB_COMPONENT,
				},
				roles: {
					enabled: [
						RolesEnum.ADMINISTRATOR,
						RolesEnum.HUB_SERVICE,
						RolesEnum.MIDDLE_OFFICE_MANAGER,
						RolesEnum.COMPLIANCE_OFFICE_MANAGER,
						RolesEnum.ACCOUNT_SERVICE
					],
				},
				menu: {
					icon: 'conta_corrente_outline',
					canBeSelected: true,
					title: 'SMA requests',
					isSelected: false,
					testid: 'sma',
					path: '/sma',
				},
			},
		},
		[MfeFeatureName.GOP]: {
			id: MfeFeatureName.GOP,
			config: {
				mfe: {
					elementName: 'mf-gop',
					remoteEntry: 'https://global-onboarding-platform-hom.cloud.itau.com.br/private/mf-gop/main.js',
					type: MfeType.WEB_COMPONENT,
				},
				roles: {
					enabled: [RolesEnum.ADMINISTRATOR, RolesEnum.COMPLIANCE_OFFICE_MANAGER],
				},
				menu: {
					icon: 'doc_invoice_base',
					canBeSelected: true,
					title: 'GOP',
					isSelected: false,
					testid: 'gop',
					path: '/gop',
				},
			},
		},
		[MfeFeatureName.SEND_STATEMENT]: {
			id: MfeFeatureName.SEND_STATEMENT,
			config: {
				mfe: {
					elementName: 'mf-mfe-backoffice-optin',
					remoteEntry:
						'https://microfrontend.hom.cloud.itau.com.br/private/mf-mfe-backoffice-optin/main.js',
					type: MfeType.WEB_COMPONENT,
					connectedToChassisRoute: true,
				},
				roles: {
					enabled: [
						RolesEnum.ADMINISTRATOR,
						RolesEnum.HUB_SERVICE,
						RolesEnum.BANKER,
						RolesEnum.ACCOUNT_SERVICE,
					],
				},
				menu: {
					icon: 'mail_send_base',
					canBeSelected: true,
					title: 'Send Statement',
					isSelected: false,
					testid: 'sendstatement',
					path: '/send-statement-mfe',
				},
			}
		},
	},
	mfePages: {
		'/dashboard-mfe': {
			headerType: 'none',
			title: '',
			rolesEnable: [
				RolesEnum.ADMINISTRATOR,
				RolesEnum.MIDDLE_OFFICE_MANAGER,
				RolesEnum.MIDDLE_OFFICE_ANALYST,
				RolesEnum.HUB_SERVICE,
				RolesEnum.ACCOUNT_SERVICE,
			],
		} as PageType,
		'/send-statement-mfe': {
			headerType: 'none',
			title: '',
			rolesEnable: [
				RolesEnum.ADMINISTRATOR,
				RolesEnum.HUB_SERVICE,
				RolesEnum.BANKER,
				RolesEnum.ACCOUNT_SERVICE,
			],
		} as PageType,
	},
};
